import { Component, Inject, OnInit, QueryList, ViewChildren, OnDestroy } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DocumentInputsComponent } from "../document-inputs/document-inputs.component";
import { NotificationService } from 'src/app/Service/notification.service';
import { DocumentOutputModel, IDocumentApprovalModel, IElementInputModel } from "src/app/ViewModel/DocumentModel";
import { FileUploadComponent } from "src/app/CommonComponents/file-upload/file-upload.component";
import { CommonService } from "src/app/Service/Common.service";
import { formatDate } from "@angular/common";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { DocumentService } from "src/app/Service/document/document.service";
import { FileUploadLibrary } from "src/app/Service/file/file.service";
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-doc-bulkupload',
  templateUrl: './bulkupload.component.html',
  styleUrls: ['./bulkupload.component.css']
})
export class BulkUploadComponent implements OnInit, OnDestroy {
  @ViewChildren(DocumentInputsComponent) docInputComp!: QueryList<DocumentInputsComponent>;
  public noOfDocsArr: number[] = [];
  public numFormat!: string;
  public docNosOf!: number;
  public readonly = false;
  public projectId: number = 0;
  public groupId: number = 0;
  public memberId: number = 0;
  public datevalue = new Date(this.getDateFormat());
  public RevisedOn: string = formatDate(this.datevalue, 'dd-MMM-yyyy', 'en-US');;
  public noOfDocs: number = 1;
  public IsSupersede: boolean = false;
  public IsEdit: boolean = false;
  public canManualNo: boolean = false;
  public rateControl = new FormControl("", [Validators.max(5), Validators.min(1)]);
  public parentForm: FormControl = new FormControl();
  autoSerialNoMap: Map<number, number> = new Map<number, number>();
  sourceDocComponent!: DocumentInputsComponent | undefined;
  autoSerialSelectedValues: Map<number, IElementInputModel[]> = new Map<number, IElementInputModel[]>();
  public popupHeader: string = "Upload Document";
  public CurrentProjectDetails!: ProjectViewModel;
  UnsubscribeArray: Subscription[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public document: any,
    private _notificationService: NotificationService,
    public dialogRef: MatDialogRef<BulkUploadComponent>,
    private dialog: MatDialog,
    private commonService: CommonService,
    private _docService: DocumentService) { }
  ngOnInit() {
    this.numFormat = 'Auto';
    this.projectId = this.commonService.getProjectId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.CurrentProjectDetails = this.commonService.getCurrentProjectDetails();
    if (this.CurrentProjectDetails && this.CurrentProjectDetails.doc_Number_Format) {
      this.numFormat = this.CurrentProjectDetails.doc_Number_Format;
    }
    this.callMemberRoleandFeature();
    if (this.document.docId != 0 && this.document.isSupersede == false) {
      this.popupHeader = "Edit - Upload Document";
      this.IsEdit = true;
    }
    if (this.document.docId != 0 && this.document.isSupersede == true) {
      this.popupHeader = "Supersede - Upload Document";
      this.IsSupersede = true;
    }
    for (let i = 0; i < this.noOfDocs; i++) {
      this.noOfDocsArr.push(i);
    }
  }

  addDocument() {
    this.sourceDocComponent = this.docInputComp.find(x => x.docIndex == 1)
    let count = this.rateControl.value;
    if (count > 0) {
      let previousCount = this.noOfDocsArr.length;
      if (count > 5) {
        count = 5;
      }
      // 1 < 3 // normal scenario
      if (previousCount < count) {
        let countdiff = count - previousCount;
        for (let i = previousCount; i < count; i++) {
          this.noOfDocsArr.push(i);
        }
      } else {
        let countdiff = previousCount - count;
        for (let i = 0; i < countdiff; i++) {
          this.noOfDocsArr.splice(previousCount - 1, countdiff);
          previousCount = previousCount - 1;
        }
      }
    }
    else {
      this._notificationService.showToast("Please enter No of Docs to Upload", "Warning");
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  async saveAllDocument() {
    let validForm: boolean = true;
    this.docInputComp.forEach(elements => {
      elements.ValidateForm();
      if (!elements.isDocumentValid) {
        validForm = false;
      }
    });
    if (validForm) {
      let results: DocumentOutputModel[] = [];
      let failureResult: string = "";
      for (let i = 0; i < this.docInputComp.length; i++) {
        let docInpComp: DocumentInputsComponent = this.docInputComp.toArray()[i];
        let x: DocumentOutputModel = await docInpComp.saveDocument();
        if (!!x)
          results.push(x);
      }
      let successResult: string = "";
      results.forEach(res => {
        if (!!res) {
          if (res.successCode == 200) {
            successResult += res.successMessage + "<br>";
          }
          else {
            failureResult += res.successMessage + "<br>";
          }
        }
      });

      if (failureResult && failureResult.length > 0) {
        this._notificationService.showPopup(failureResult, "Warning");
        //this.closeDialog();
      }
      if (successResult && successResult.length > 0) {
        this.closeDialog();
        if (this.IsEdit != true && results.length == 1) {
          this.attachmentClick(results[0].DocId, results[0].RevisionNo, results[0].DocAuthorizedBy);
        }
        if (this.IsSupersede) {
          this._notificationService.showPopup("Document superseded successfully", "Success");
        }
        else {

          this._notificationService.showPopup(successResult, "Success");
        }
      }

    }
    else {
      this._notificationService.showToast("Mandatory fields are Required", "Warning");
    }
  }

  reSetAll() {
    this.docInputComp.forEach(x => x.reSet());
  }

  onValChange(value: string) {
    this.numFormat = value;
  }
  onInputValChange() {
    this.docNosOf = this.rateControl.value;
  }

  getDocumentSerialNo(value: any) {
    this.autoSerialSelectedValues.set(value.index, value.selectedDedIds);
    this.autoSerialNoMap.set(value.index, value.serialNo);
    if (this.autoSerialSelectedValues.size > 1) {
      this.autoSerialSelectedValues.forEach((x, y) => {
        if (y != value.index && JSON.stringify(x) == JSON.stringify(value.selectedDedIds)) {
          let _x: any = this.autoSerialNoMap.get(y);
          if (_x)
            this.autoSerialNoMap.set(value.index, _x + 1)
        }
      })
    }
  }

  attachmentClick(result: number, RevisionNo: string, authorizedBy: number|null) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      //height: '50%',
      width: '50%',
      data: { projectId: this.projectId, docId: result, revisionNo: RevisionNo, moduleName: 'EDMS', libraryName: FileUploadLibrary.Documents, createdBy: this.memberId, documents: [{ value: result, text: "", revisionNo: RevisionNo, task_SNo: 0 }], isEditable: false },
    });
    dialog.afterClosed().subscribe((res: any) => {
      if (authorizedBy == this.memberId) {
        let inputModel: IDocumentApprovalModel = {
          DocId: result,
          RevisionNo: RevisionNo,
          RevisedOn: this.RevisedOn,
          IsApproved: true,
          ApprovedBy: this.memberId
        };
        let Attachmentclick = this._docService.DocumentApproval(inputModel).subscribe((res: StandardOutputModel) => {
          if (res.successCode == 200) {
            this._notificationService.showToast(res.successMessage, "Success");
          }
          else if (res.successCode == 500) {
            this._notificationService.showToast(res.successMessage, "Error");
          }
        });
        this.UnsubscribeArray.push(Attachmentclick);
      }
    });
  }
  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }

  async callMemberRoleandFeature() {
    let memberrolefeature = await this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((result1: any[]) => {
      this.canManualNo = result1.some(data => data.feature_Desc == 'Manual No');
      if (!this.canManualNo && this.numFormat == 'Manual')
        this.numFormat = 'Auto';
    });
    this.UnsubscribeArray.push(memberrolefeature);
  }

  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }
}
